"use strict";

var _classCallCheck = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subscribable = void 0;

var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    _classCallCheck(this, Subscribable);

    this.subscribers = new Set();
  }

  _createClass(Subscribable, [{
    key: "subscribe",
    value: function subscribe(cb) {
      var _this = this;

      this.subscribers.add(cb);
      return function () {
        _this.subscribers.delete(cb);
      };
    }
  }, {
    key: "publish",
    value: function publish(msg) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var topic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      this.subscribers.forEach(function (cb) {
        return cb(msg, value, topic);
      });
    }
  }]);

  return Subscribable;
}();

exports.Subscribable = Subscribable;